import { normalizeDateValue } from "./trialStatus";

export function getSubscriptionResumeDate(user, { now = new Date() } = {}) {
  if (!user?.subscriptionPause?.active) return null;

  const resumeDate = normalizeDateValue(user.subscriptionPause.resumeDate);
  if (!resumeDate) return null;

  const nowDate = normalizeDateValue(now) || new Date();
  if (resumeDate.getTime() <= nowDate.getTime()) return null;

  return resumeDate;
}

export function isSubscriptionPaused(user, options = {}) {
  if (!user?.subscriptionPause?.active) return false;
  return getSubscriptionResumeDate(user, options) !== null
    || !user.subscriptionPause.resumeDate;
}

export function formatSubscriptionResumeDate(user, { fallback = "your resume date", now = new Date() } = {}) {
  const resumeDate = getSubscriptionResumeDate(user, { now })
    || normalizeDateValue(user?.subscriptionPause?.resumeDate);

  if (!resumeDate) return fallback;

  return new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(resumeDate);
}
